import * as React from 'react';
import { useState, useContext } from 'react';
import Svg from '../shared/Svg';
import { useDispatch, useSelector } from 'react-redux';
import colors from '../../utils/colors';
import { handleLogout } from '../../utils/auth';
import * as RootActions from '../../actions/index';
import { UserContext } from '../App';
import { logoutSuccess } from '../../actions/auth';
import './Footer.scss';

export const Footer = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const forcedUserLogOut = useSelector((state) => state.auth.forcedUserLogOut);
  const uninterruptedModeEnabled = useSelector((state) => state.mail.settings?.syncSettingsAndUsageReport?.uninterruptedModeEnabled);
  const hasRefreshTokenIssue = useSelector((state) => state.auth.user?.hasRefreshTokenIssue);
  const user = useContext(UserContext);
  const docrioNamespace = useSelector((state) => state.mail.settings?.override?.docrioNamespace || 'litify_docs');
  const adminSettingsUrl = `${user?.salesforceInstanceUrl}/lightning/n/${docrioNamespace}__Email_Admin_Settings`;
  const isAdmin = user?.admin;
  const [menuHover, setMenuHover] = useState(false);
  const dispatch = useDispatch();

  const version = process.env.VERSION || 'Beta';

  const openSettings = () => {
    setMenuHover(!menuHover);
    window.open(adminSettingsUrl, '_blank');
  };

  const onLogoutClicked = async () => {
    await handleLogout(dispatch);
  };

  const onLoginClicked = () => {
    dispatch(RootActions.clearAlertText());
    dispatch(RootActions.setInitializationError(false));
    localStorage.clear();
    dispatch(logoutSuccess());
  };

  const authenticatedWithoutForceLogout = isAuthenticated && !forcedUserLogOut;
  const [buttonLabel, onAuthClicked] = (uninterruptedModeEnabled && hasRefreshTokenIssue && authenticatedWithoutForceLogout) ?
      ['Login', onLogoutClicked] :
      (authenticatedWithoutForceLogout) ?
        ['Logout', onLogoutClicked] :
        ['Login', onLoginClicked];

  return (
    <div className='footer-container'>
      <div className='footer-watermark-container'>
        <Svg
          className='footer-watermark'
          data='/assets/footerWatermark.svg'
        />
      </div>
      <div className='footer-litify-text'>
        {[...Array(6).keys()].map((i) => {
          return (<Svg
            className='footer-watermark-letter'
            key={i}
            data={`/assets/Fill ${i}.svg`}
            fill={colors.white}
          />);
        })}
      </div>
      <div className='footer-version'>
        {version}
      </div>
      {
        isAdmin &&
        <button
          id='settings-button'
          className='footer-settings-button'
          onClick={openSettings}
          onMouseEnter={() => setMenuHover(!menuHover)}
          onMouseOut={() => setMenuHover(!menuHover)}
        >
          <Svg
            className='footer-icon outlook-footer-icon-settings'
            data='/assets/settings.svg'
            fill={colors.white}
            hoverable
            currentHoveringState={menuHover}
            hoverFill={colors.hover}
            onClick={openSettings}
          />
        Settings
        </button>
      }
      <button
        id='auth-button'
        className='footer-auth-button outlook-footer-icon-auth'
        onClick={onAuthClicked}
        onMouseEnter={() => setMenuHover(!menuHover)}
        onMouseOut={() => setMenuHover(!menuHover)}
      >
        <Svg
          className='footer-icon'
          data='/assets/logout.svg'
          fill={colors.white}
          hoverable
          hoverFill={colors.hover}
          onClick={onAuthClicked}
        />
        {buttonLabel}
      </button>
    </div>
  );
};
